import React from 'react';
import ProductListItem from './ProductListItem';
import { useTranslation } from 'react-i18next';
import { ErrorHandler } from '../../ErrorHandler';

const ProductList = ({ items = [] }) => {
    const { i18n } = useTranslation();

    return (
        <article className="product__article-item">
            {items.length ?
                <ul className="product__list product__list_grid">
                    {items.map(it => (
                        <li key={it.id}
                            className={`product__list-item ${it.isDeleted ? 'product__list-item_deleted' : ''}`}>
                            <ProductListItem product={it} />
                        </li>
                    ))}
                </ul>
                :
                <ErrorHandler titleValue={i18n.t('app.page.profile.emptyData')}/>}
        </article>
    );
};

export default ProductList;
